import { formatPrice } from '@rcg/pricing-format';
import { CruiseCardTaggingAttrs, GetDockedTimeRangeParams } from 'components/CruiseCard/CruiseCard.types';
import { format, parse } from 'date-fns';
import { Cruise } from 'types';

export const getLabelByLength = (length: number, singularLabel: string, pluralLabel: string): string => {
	return length > 1 ? pluralLabel : singularLabel;
};

export const getDatesButtonLabel = (sailingsCount: number, singularLabel: string, pluralLabel: string): string => {
	return getLabelByLength(sailingsCount, singularLabel, pluralLabel).replace('{{dates}}', sailingsCount.toString());
};

export const getPriceDisclosureStartingLabel = (label: string, locale: { currency: string }): string => {
	return label.replace('{{currencyCode}}', locale.currency);
};

export const capitalizeFirstLetter = (label: string) => {
	return String(label).charAt(0).toUpperCase() + String(label).slice(1);
};

export const getPriceDisclosureValidLabel = (label: string, strDate: string, language: string): string => {
	const [parsedYear, parsedMonth, parsedDay] = strDate.split('-').map(Number);
	const date = new Date(parsedYear, parsedMonth - 1, parsedDay);
	const defaultMonth = date.toLocaleString(language, { month: 'long' });
	const month = capitalizeFirstLetter(defaultMonth).substring(0, 3);
	const day = date.toLocaleString(language, { day: 'numeric' });
	const year = date.toLocaleString(language, { year: 'numeric' });

	return label.replace('{{dateRange}}', `${month} ${day}, ${year}`);
};

export const getPriceDisclosureTaxesAndFeesLabel = (label: string, locale: { currency: string }, taxesAndFees: number): string => {
	return label.replace('{{value}}', `${formatPrice(taxesAndFees, locale.currency, true, true, true)}`);
};

export const getTaggingAttrs = (cruise: Cruise, listItemIndex: number): CruiseCardTaggingAttrs => {
	const {
		featuredSailing,
		id: cruiseId,
		itinerary,
		sailings,
		cruiseSrc: { productViewLink },
	} = cruise;

	return {
		id: `cruise-card_${cruiseId}`,
		'data-selector': listItemIndex,
		'data-group-id': cruiseId,
		'data-package-code': itinerary.code,
		'data-ship-code': itinerary.ship.code,
		'data-destination-code': itinerary.departurePort.code,
		'data-sail-date': featuredSailing.sailDate,
		'data-start-date': featuredSailing.startDate,
		'data-end-date': featuredSailing.endDate,
		'data-first-sail-date': sailings[0]?.sailDate,
		'data-last-sail-date': sailings[sailings.length - 1]?.sailDate,
		'data-product-view-link': productViewLink,
		'data-testid': `cruise-card-container_${cruiseId}`,
	};
};

export const getDockedTimeRange = ({ arrivalTime, departureTime, labels }: GetDockedTimeRangeParams): string => {
	const formattedArrivalTime = arrivalTime ? format(parse(arrivalTime, 'HH:mm:ss', new Date()), 'h:mma').toLowerCase() : '';

	const formattedDepartureTime = departureTime ? format(parse(departureTime, 'HH:mm:ss', new Date()), 'h:mma').toLowerCase() : '';

	if (formattedArrivalTime && formattedDepartureTime) {
		return `${labels.docked}: ${formattedArrivalTime} - ${formattedDepartureTime}`;
	}

	if (formattedArrivalTime) {
		return `${labels.arrival}: ${formattedArrivalTime}`;
	}

	if (formattedDepartureTime) {
		return `${labels.departs}: ${formattedDepartureTime}`;
	}

	return '';
};
